export default "__VITE_ASSET__Cbx$0Eay__"